import React, { Component } from "react";
import { Spin, Select } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";
import './Styles.css';

const { Option } = Select;

class SelectTiposAcumuladosItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: [],
      cargando: false,
      primerCarga: false,
    };

    this.buscarTiposAcumulados = debounce(this.buscarTiposAcumulados.bind(this), 300);
  }

  componentDidMount() {
    this.buscarTiposAcumulados('');
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      if (this.props.value) {
        const buscarTipoAcumulado = this.state.opciones.find(
          (tipoAcumulado) => tipoAcumulado._id.toString() === this.props.value.toString()
        );
        if (!buscarTipoAcumulado) {
          this.buscarTiposAcumulados(this.props.value || '');
        }
      }
    }
  }

  async buscarTiposAcumulados(texto) {
    this.setState({ cargando: true });
    try {
      const res = await axios.post(
        "tiposAcumulados/selectTiposAcumuladosItem",
        {
          empresaId: this.props.empresaId,
          query: texto,
          values: this.props.value,
        },
        {
          headers: this.props.headersToken,
        }
      );

      if (res.data.success === 2) {
        this.setState({
          opciones: res.data.tiposAcumulados,
          primerCarga: true,
        });
      } else {
        this.setState({ opciones: [] });
      }
    } catch (error) {
      console.error("Error al buscar tipos de acumulados:", error);
      this.setState({ opciones: [] });
    } finally {
      this.setState({ cargando: false });
    }
  }

  render() {
    const {
      noBuscar,
      mode,
      mostrarCarga,
      disabled,
      fondoBlanco,
      sinBorde,
      width,
      style,
      placeholder,
      ...restProps
    } = this.props;

    const propsNuevas = {
      showSearch: !noBuscar,
      filterOption: false,
      mode: mode,
      onSearch: this.buscarTiposAcumulados,
      notFoundContent: this.state.cargando ? (
        <div style={{ textAlign: "center", padding: "8px" }}>
          <div style={{ marginTop: "8px", fontSize: "12px", color: "#999" }}>
            Buscando tipos de acumulados...
          </div>
        </div>
      ) : this.state.primerCarga ? (
        "No se encontraron tipos de acumulados"
      ) : null,
      loading: this.state.cargando,
    };

    if (mode === "multiple") {
      propsNuevas.maxTagCount = "responsive";
    }

    const estiloFinal = {
      color: disabled ? "black" : "inherit",
      backgroundColor: disabled ? (fondoBlanco ? "white" : "white") : null,
      borderBottom: sinBorde ? "none" : "1px solid #E0FFFFFF",
      borderRadius: "4px",
      transition: "border-color 0.3s ease",
      boxShadow: sinBorde ? "none" : "0 1px 3px rgba(0, 0, 0, 0.1)",
      width: width || undefined,
      opacity: disabled ? 1 : undefined,
      ...style,
    };

    return (
      <Select
        className={`custom-disabled-select ${disabled ? "custom-disabled" : ""}`}
        dropdownMatchSelectWidth={400}
        disabled={disabled}
        dropdownRender={(menu) => (
          <Spin spinning={this.state.cargando}>
            {menu}
          </Spin>
        )}
        {...propsNuevas}
        {...restProps}
        onChange={(value) => {
          const tipoAcumulado = this.state.opciones.find(
            (tipoAcumulado) => tipoAcumulado._id === value
          );
          this.props.onChange(value, tipoAcumulado);
        }}
        placeholder={
          this.state.cargando && !this.state.primerCarga
            ? "Cargando..."
            : placeholder
        }
        style={estiloFinal}
        bordered={false}
      >
        {this.state.opciones.map((tipoAcumulado) => (
          <Option key={tipoAcumulado._id} value={tipoAcumulado._id}>
            {tipoAcumulado.stringBuscar}
          </Option>
        ))}
      </Select>
    );
  }
}

export default SelectTiposAcumuladosItem;